import { AddCircle, RemoveCircle } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import Card from 'components/Card/Card';
import Image from 'components/Image/Image';
import { capitalize, round } from 'helpers';
import * as setup from 'setup';

export default function SimulationControls({ allocation, disableDecrease, disableIncrease, iconLabel, type, onChange }: SimulationControlsProps) {

    function handleChange(increase: boolean) {
        const newAllocation = round((increase ? 1 : -1) * setup.simulation.allocation.step + allocation, 3);
        onChange(newAllocation);
    }

    return <Card align="center" id={`simulationControls${capitalize(type)}`} info={`simulation${capitalize(type)}Info`}>
        <Box padding={1}>
            <Image alt={`Icon of a ${iconLabel}`} src={`/assets/simulation/${type}.svg`} style={{ maxHeight: 40 }} />
        </Box>
        <Typography component="h2" variant="roboto518">
            {type.toUpperCase()}
        </Typography>
        <Box alignItems="center" display="flex" justifyContent="space-between" marginTop={2} marginX={-0.5}>
            <IconButton aria-label={`decrease ${type} allocation by ${Math.round(setup.simulation.allocation.step * 100)}%`} disabled={allocation === 0 || disableDecrease} onClick={() => handleChange(false)}>
                <RemoveCircle />
            </IconButton>
            <Typography marginX={-1} variant="roboto721">
                <Box component="span" sx={visuallyHidden}>
                    {type} allocation:
                </Box>
                {Math.round(allocation * 100)}%
            </Typography>
            <IconButton aria-label={`increase ${type} allocation by ${Math.round(setup.simulation.allocation.step * 100)}%`} disabled={allocation === 1 || disableIncrease} onClick={() => handleChange(true)}>
                <AddCircle />
            </IconButton>
        </Box>
    </Card>;

}